export const MAX_RESUME_SIZE = 4 * 1024 * 1024;
